module.exports = __webpack_public_path__ + "img/Blue-R-2@2x.70628679.png";